<template>
  <div class="div-bg">
    <img class="bg-img" src="@/assets/images/contact-feedback-bg.png" />
    <p class="p-title">建议反馈</p>
    <p class="p-desc">Advice feedback</p>

    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline textarea"
    >
      <el-row>
        <el-form-item>
          <el-input
            v-model="formInline.name"
            placeholder="您的公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="formInline.user" placeholder="您的姓名"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-input
            v-model="formInline.phone"
            placeholder="您的电话"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="formInline.email"
            placeholder="您的邮箱账号"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-input
          type="textarea"
          v-model="formInline.desc"
          placeholder="请输入意见反馈"
        ></el-input>
      </el-row>
    </el-form>

    <!-- <b-form-textarea
      class="textarea"
      id="textarea"
      placeholder="请输入意见反馈"
      rows="6"
      max-rows="8"
      v-model="content"
    >
    </b-form-textarea> -->
    <b-button class="button" @click="click">提交</b-button>
  </div>
</template>

<script>
export default {
  name: "ContactFeedback",
  data() {
    return {
      content: "",
      formInline: {}
    };
  },
  methods: {
    click() {
      this.formInline = {};
      this.$message({
        message: "感谢您宝贵意见和建议，我们将认真处理！",
        type: "success"
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.div-bg {
  position: relative;

  .bg-img {
    width: 100%;
  }

  .p-title {
    position: absolute;
    top: 3rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 1.9rem;
    color: #ffffff;
  }

  .p-desc {
    position: absolute;
    top: 6rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.8rem;
    color: #ffffff;
  }

  .textarea {
    position: absolute;
    top: 10rem;
    // width: 40%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.6;
  }

  .button {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 2.5rem;
    width: 10rem;
    height: 3rem;
    color: #f1f1f1;
    background-color: #12b7f6;
  }

  .el-form-item {
    margin-right: 0px;
  }

  .el-input--small {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/contact/components/ContactFeedback.vue